































































import { component as FetchDataComposer } from '@/composers/fetch-data';
import { component as StoreRegisterComposer } from '@/composers/store-register';
import store from '../../store/materials';
import View from './View';

const storeName = 'materials';

export default FetchDataComposer(
  StoreRegisterComposer(
    storeName,
    store,
    View(storeName),
  ),
) as IView;
